import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MENU_OPTIONS } from '@shared/constants/left-menu-option';

const MENU_ROUTE_MAP: Record<string, string> = {
  [MENU_OPTIONS.DEVICES]:       '/devices',
  [MENU_OPTIONS.MONITORING]:    '/monitoring',
  [MENU_OPTIONS.TIMELINE]:      '/timeline',
  [MENU_OPTIONS.EVENT]:         '/event',
  [MENU_OPTIONS.CONTROL_POINT]: '/control-point',
};

export const homeRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const savedMenu = localStorage.getItem('currentMenu');
  const route = savedMenu ? MENU_ROUTE_MAP[savedMenu] : null;

  if (route) {
    return router.createUrlTree([route]);
  }

  // No saved menu → redirect to control-point by default
  return router.createUrlTree(['/control-point']);
};
